import { TemplateRef } from '@angular/core';
import { GasIcon } from '../../utils/gas-icons/icon/gas-icon.namespace';

/**
 * @description Namespace for GasNotifications. Keep enums, interfaces, types and other
 */
export namespace GasNotification {
    export interface Notification {
        type: Type;
        title?: string;
        message?: string;
        link?: string;
        linkCallback?: () => void;
        id?: string;
        deleted?: boolean;
        clickClose?: boolean;
        rightContent?: TemplateRef<HTMLElement>;
    }

    export enum Type {
      Simple = 'simple',
      Error = 'error',
      Warning = 'warning',
      General = 'general',
      Success = 'success',
      LightSimple = 'light-simple',
      LightError = 'light-error',
      LightWarning = 'light-warning',
      LightGeneral = 'light-general',
      LightSuccess = 'light-success',
    }

    export function getIcon(type: GasNotification.Type): GasIcon.Notifications {
      const typeIcons = {
        [GasNotification.Type.Simple]: null,
        [GasNotification.Type.Warning]: GasIcon.Notifications.Warning,
        [GasNotification.Type.General]: GasIcon.Notifications.General,
        [GasNotification.Type.Error]: GasIcon.Notifications.Error,
        [GasNotification.Type.Success]: GasIcon.Notifications.Success,
        [GasNotification.Type.LightSimple]: null,
        [GasNotification.Type.LightWarning]: GasIcon.Notifications.LightWarning,
        [GasNotification.Type.LightGeneral]: GasIcon.Notifications.LightGeneral,
        [GasNotification.Type.LightError]: GasIcon.Notifications.LightError,
        [GasNotification.Type.LightSuccess]: GasIcon.Notifications.LightSuccess,
      };

      if (!typeIcons[type]) {
        return null;
      }

      return typeIcons[type];
    }
}
